import { HotelOfferDetail } from "shared/types/hotels";

type MapViewport = {
  latMin: number;
  lngMin: number;
  latMax: number;
  lngMax: number;
} | null;

const filterMapViewPort = (mapViewport: MapViewport) => (
  hotelOffer: HotelOfferDetail
): boolean => {
  if (!mapViewport) {
    return true;
  }

  const location = hotelOffer?.HotelDescription?.LocationDetails?.Location?.find(
    (loc) => loc.Code === "GEO-SIGNED"
  );

  if (!location?.$t) {
    return false;
  }

  const [latStr, lngStr] = location.$t.split(",").map((s) => s.trim());
  const lat = parseFloat(latStr);
  const lng = parseFloat(lngStr);

  if (isNaN(lat) || isNaN(lng)) {
    return false;
  }

  const { latMin, lngMin, latMax, lngMax } = mapViewport;

  return lat >= latMin && lat <= latMax && lng >= lngMin && lng <= lngMax;
};

export default filterMapViewPort;
